export default __webpack_public_path__ + "static/media/like-icon.9b393539.svg";